import { Component, type ReactNode } from "react";

// Sin esto, cualquier error al renderizar deja la pantalla en blanco.
export default class AppErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error("App error:", error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="flex min-h-screen items-center justify-center bg-background p-4">
        <div className="max-w-sm space-y-4 text-center">
          <p className="text-lg font-semibold text-foreground">Algo no cargó bien</p>
          <p className="text-muted-foreground">Tocá el botón para volver a intentar.</p>
          <button
            onClick={() => window.location.reload()}
            className="h-12 rounded-md bg-primary px-8 text-primary-foreground"
          >
            Reintentar
          </button>
        </div>
      </div>
    );
  }
}
